export default __webpack_public_path__ + "static/media/Drum.fd184f30.png";